import React, { FC } from "react";
import { B2Modal, B2Button } from "@hdb/biome-2";
import HasPermission from "src/core/guards/has-permission";

interface ModalComponentProps {
    showModal: boolean;
    handleClose?: () => void;
    size?: "sm" | "lg" | "xl";
    centered?: boolean;
    headerTitle: React.ReactNode;
    actionConfig?: any;
    isConformationModal?: boolean;
    children: React.ReactNode;
    isIdleModal?: boolean;
    isViewMode?: boolean;
    backdropClassName?: string;
    isClosable?: boolean;
    footerAlign?: "flex-start" | "flex-end" | "center";
}
const NewModalComponent: FC<ModalComponentProps> = ({
    showModal,
    handleClose,
    size = "lg",
    centered = true,
    headerTitle,
    actionConfig,
    isConformationModal = false,
    children,
    isIdleModal = false,
    isViewMode,
    backdropClassName = null,
    isClosable = true,
    footerAlign = "flex-start",
}) => {
    return (
        <B2Modal
            show={showModal}
            onHide={
                handleClose
                    ? handleClose
                    : () => {

                    }
            }
            size={size}
            centered={centered}
            backdropClassName={backdropClassName ? backdropClassName : ""}
        >
            {isClosable ? (
                <B2Modal.Header closeButton>
                    <B2Modal.Title>
                        <div style={{ padding: "1rem" }}>{headerTitle}</div>
                    </B2Modal.Title>
                </B2Modal.Header>
            ) : (
                <B2Modal.Header>
                    <B2Modal.Title>
                        <div style={{ padding: "1rem" }}>{headerTitle}</div>
                    </B2Modal.Title>
                </B2Modal.Header>
            )}

            <B2Modal.Body>
                <div style={{ padding: "0 1rem" }}>{children}</div>
            </B2Modal.Body>
            <B2Modal.Footer>
                <div
                    style={{
                        padding: "1rem",
                        display: "flex",
                        justifyContent: footerAlign,
                        gap: "8px",
                        width: "100%",
                    }}
                >
                    {isConformationModal ? (
                        !isIdleModal && (
                            <B2Button
                                variant="secondary"
                                onClick={handleClose}
                            >
                                No
                            </B2Button>
                        )
                    ) : !isViewMode ? (
                        <B2Button
                            variant="secondary"
                            onClick={handleClose}
                        >
                            Cancel
                        </B2Button>
                    ) : null}

                    {actionConfig &&
                        actionConfig.map((action: any, index: number) =>
                            action?.isHasPermissionEnabled ? (
                                <HasPermission
                                    moduleName={action?.moduleName}
                                    actionName={action?.actionName}
                                    isRoute={false}
                                >
                                    <B2Button
                                        key={index}
                                        onClick={action.event}
                                        variant="primary" // action.variant
                                        disabled={
                                            action.hasOwnProperty("disabled")
                                                ? action.disabled
                                                : false
                                        }
                                    >
                                        {action.label}
                                    </B2Button>
                                </HasPermission>
                            ) : (
                                <B2Button
                                    key={index}
                                    onClick={action.event}
                                    variant="primary" // action.variant
                                    disabled={
                                        action.hasOwnProperty("disabled") ? action.disabled : false
                                    }
                                >
                                    {action.label}
                                </B2Button>
                            )
                        )}
                </div>
            </B2Modal.Footer>
        </B2Modal>
    );
};

export default NewModalComponent;